"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetRawEventsSortToJSON = exports.GetRawEventsSortFromJSONTyped = exports.GetRawEventsSortFromJSON = exports.GetRawEventsSort = void 0;
/**
 *
 * @export
 * @enum {string}
 */
var GetRawEventsSort;
(function (GetRawEventsSort) {
    GetRawEventsSort["CREATEDAT"] = "CREATED_AT";
})(GetRawEventsSort = exports.GetRawEventsSort || (exports.GetRawEventsSort = {}));
function GetRawEventsSortFromJSON(json) {
    return GetRawEventsSortFromJSONTyped(json, false);
}
exports.GetRawEventsSortFromJSON = GetRawEventsSortFromJSON;
function GetRawEventsSortFromJSONTyped(json, ignoreDiscriminator) {
    return json;
}
exports.GetRawEventsSortFromJSONTyped = GetRawEventsSortFromJSONTyped;
function GetRawEventsSortToJSON(value) {
    return value;
}
exports.GetRawEventsSortToJSON = GetRawEventsSortToJSON;
